import { useMutation } from '@tanstack/react-query'
import { signUpUser } from '../index'

const useSignUpUser = () =>
  useMutation({
    mutationFn: signUpUser,
  })

export default useSignUpUser
